// extracted by mini-css-extract-plugin
export default {"stage":"styles_stage__S0lXJ","rotate":"styles_rotate__xD84o","ring":"styles_ring__9XNmC","poster":"styles_poster__ZTqy9"};